import { Container, List, ListItemButton, ListItemText } from "@mui/material";
import React, { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { NavigationConfig } from "./types/navigationConfigType";
import PageThemeContext from "../../Contexts/pageThemeContext";

// eslint-disable-next-line @typescript-eslint/no-require-imports
const classNames = require("classnames");

interface NavigationMenuItemProps {
  navigations: NavigationConfig[];
  close: () => void;
}

const NavigationMenuItem: FC<NavigationMenuItemProps> = (props) => {
  const { navigations, close } = props;
  const navigate = useNavigate();
  const theme = useContext(PageThemeContext);
  const topNavigationMenuClass = classNames(
    "navigationMenuItem",
    `page-theme-${theme}`
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.2 }}
    >
      <Container className={topNavigationMenuClass}>
        <div className="poppover-tip" />
        <List>
          {navigations.map((nav, i) => (
            <ListItemButton
              key={nav.path || nav.title}
              component={motion.div}
              initial={{ opacity: 0, x: -4 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.04 }}
              whileHover={{ x: 4 }}
              onClick={() => {
                if (nav.isExternal) {
                  window.location.assign(nav.path || "");
                } else {
                  navigate(nav.path || "");
                }
                close();
              }}
              className="navigationMenuItemContent"
            >
              <ListItemText primary={nav.title} />
            </ListItemButton>
          ))}
        </List>
      </Container>
    </motion.div>
  );
};

export default NavigationMenuItem;
